// Een bestand in een notitie dat we niet kunnen tonen: een pdf, een zip, een logbestand.
//
// Als kaartje in de tekst, met de naam en de grootte erop, en een klik downloadt hem. Bewust
// geen <iframe> of ingebouwde viewer: de server stuurt deze bestanden met opzet als download
// en niet inline, want een pdf of svg in onze eigen pagina draait daar met jouw sessie erbij.

import { Node, mergeAttributes } from "@tiptap/core";

export type BijlageOpties = {
  HTMLAttributes: Record<string, unknown>;
};

/** "1,4 MB" leest prettiger dan 1468006. */
export function leesbareGrootte(bytes: number): string {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} kB`;
  return `${(kb / 1024).toFixed(1).replace(".", ",")} MB`;
}

export const Bijlage = Node.create<BijlageOpties>({
  name: "bijlage",
  group: "block",
  atom: true,
  draggable: true,
  selectable: true,

  addOptions() {
    return { HTMLAttributes: {} };
  },

  addAttributes() {
    return {
      url: { default: "" },
      naam: { default: "bijlage" },
      grootte: { default: 0 },
      mime: { default: "" }
    };
  },

  parseHTML() {
    return [{ tag: "a[data-bijlage]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const naam = String(node.attrs.naam ?? "bijlage");
    // Komt de bijlage uit markdown (een import, of de bron-modus), dan kennen we de grootte
    // niet. Dan liever niets tonen dan een misleidende "0 B".
    const bytes = Number(node.attrs.grootte ?? 0);
    const maat = bytes > 0 ? leesbareGrootte(bytes) : "";
    return [
      "a",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-bijlage": "1",
        class: "bijlage",
        href: String(node.attrs.url ?? ""),
        download: naam,
        // De download opent nooit in dit tabblad, maar dit voorkomt dat een nieuw tabblad
        // bij ons in het geheugen kan.
        rel: "noopener noreferrer"
      }),
      ["span", { class: "bijlagenaam" }, naam],
      ["span", { class: "bijlagemaat" }, maat]
    ];
  }
});
